var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/table-cursor.ts
import {
  Editor as Editor5,
  Node as Node4,
  Path,
  Point as Point2,
  Range,
  Transforms
} from "slate";

// src/weak-maps.ts
var EDITOR_TO_WITH_TABLE_OPTIONS = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_SELECTION = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_SELECTION_SET = /* @__PURE__ */ new WeakMap();

// src/utils/matrices.ts
import { Editor as Editor2 } from "slate";

// src/utils/is-element.ts
import { Editor, Element } from "slate";
function isElement(node) {
  return !Editor.isEditor(node) && Element.isElement(node) && "type" in node;
}

// src/utils/is-of-type.ts
function isOfType(editor, ...types) {
  const options = EDITOR_TO_WITH_TABLE_OPTIONS.get(editor), elementTypes = types.map((type) => {
    var _a;
    return (_a = options == null ? void 0 : options.blocks) == null ? void 0 : _a[type];
  });
  return (node) => isElement(node) && elementTypes.includes(node.type);
}

// src/utils/matrices.ts
function* matrices(editor, options = {}) {
  const [table] = Editor2.nodes(editor, {
    match: isOfType(editor, "table"),
    at: options.at
  });
  if (!table) {
    return [];
  }
  const [, tablePath] = table;
  for (const [, path] of Editor2.nodes(editor, {
    match: isOfType(editor, "thead", "tbody", "tfoot"),
    at: tablePath
  })) {
    const matrix2 = [];
    for (const [, trPath] of Editor2.nodes(editor, {
      match: isOfType(editor, "tr"),
      at: path
    })) {
      matrix2.push([
        ...Editor2.nodes(editor, {
          match: isOfType(editor, "th", "td"),
          at: trPath
        })
      ]);
    }
    yield matrix2;
  }
}

// src/utils/filled-matrix.ts
function filledMatrix(editor, options = {}) {
  const filled = [];
  for (const matrix2 of matrices(editor, { at: options.at })) {
    const filledSection = [];
    for (let x = 0; x < matrix2.length; x++) {
      if (!filledSection[x]) {
        filledSection[x] = [];
      }
      for (let y = 0, offset = 0; y < matrix2[x].length; y++) {
        const [{ rowSpan = 1, colSpan = 1 }] = matrix2[x][y];
        for (let c = 0, occupied = 0; c < colSpan + occupied; c++) {
          if (filledSection[x][y + c + offset]) {
            occupied++;
            continue;
          }
          for (let r = 0; r < rowSpan; r++) {
            if (!filledSection[x + r]) {
              filledSection[x + r] = [];
            }
            filledSection[x + r][y + c + offset] = [
              matrix2[x][y],
              // entry
              {
                rtl: c - occupied + 1,
                ltr: colSpan - c + occupied,
                ttb: r + 1,
                btt: rowSpan - r
              }
            ];
          }
        }
        offset += colSpan - 1;
      }
    }
    filled.push(...filledSection);
  }
  return filled;
}

// src/utils/has-common.ts
import { Editor as Editor3, Node as Node2 } from "slate";
function hasCommon(editor, [path, another], ...types) {
  const [node, commonPath] = Node2.common(editor, path, another);
  if (isOfType(editor, ...types)(node, commonPath)) {
    return true;
  }
  return !!Editor3.above(editor, {
    match: isOfType(editor, ...types),
    at: commonPath
  });
}

// src/utils/matrix.ts
import { Editor as Editor4, Node as Node3, Span as Span2 } from "slate";
function* matrix(editor, options = {}) {
  const { at, reverse } = options;
  const [table] = Editor4.nodes(editor, {
    match: isOfType(editor, "table"),
    at
  });
  if (!table) {
    return;
  }
  const [, tablePath] = table;
  for (const [, rowPath] of Editor4.nodes(editor, {
    at: Span2.isSpan(at) ? at : tablePath,
    match: isOfType(editor, "tr"),
    reverse
  })) {
    const cells = [];
    for (const [cell, path] of Node3.children(editor, rowPath, { reverse })) {
      if (isElement(cell)) {
        cells.push([cell, path]);
      }
    }
    yield cells;
  }
}

// src/utils/point.ts
var Point = class {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
  static valueOf(x, y) {
    return new this(x, y);
  }
  static equals(point, another) {
    return point.x === another.x && point.y === another.y;
  }
};

// src/table-cursor.ts
var TableCursor = {
  /** @returns {boolean} `true` if the selection is inside a table, otherwise `false`. */
  isInTable(editor, options = {}) {
    const [table] = Editor5.nodes(editor, {
      match: isOfType(editor, "table"),
      at: options.at
    });
    return !!table;
  },
  /**
   * Moves the cursor to the cell above the current selection.
   * @param {'start' | 'end' | 'all'} [options.mode] - Specifies the selection mode,
   * which can be one of the following: `start` to move the cursor to the beginning
   * of the cell's content, `end` to move it to the end, or `all` to extend the
   * selection over the entire cell's content.
   * @returns {boolean} `true` if the action was successful, `false` otherwise.
   */
  upward(editor, options = {}) {
    if (!editor.selection) {
      return false;
    }
    const [table, td] = Editor5.nodes(editor, {
      match: isOfType(editor, "table", "th", "td")
    });
    if (!table || !td) {
      return false;
    }
    const [, tablePath] = table;
    const [, tdPath] = td;
    const m = filledMatrix(editor, { at: tablePath });
    let previous;
    let indexY = 0;
    outer:
      for (let x = 0; x < m.length; x++) {
        for (indexY = 0; indexY < m[x].length; indexY++) {
          const [[, path2], { ltr: colSpan }] = m[x][indexY];
          if (Path.equals(path2, tdPath)) {
            break outer;
          }
          indexY += colSpan - 1;
        }
        previous = m[x];
      }
    if (!previous || !previous[indexY]) {
      if (Path.hasPrevious(tablePath)) {
        Transforms.select(editor, Editor5.end(editor, Path.previous(tablePath)));
        return true;
      }
      return false;
    }
    const [[, path]] = previous[indexY];
    options.mode === "all" ? Transforms.select(editor, path) : Transforms.select(
      editor,
      options.mode === "start" ? Editor5.start(editor, path) : Editor5.end(editor, path)
    );
    return true;
  },
  /**
   * Moves the cursor to the cell below the current selection.
   * @param {'start' | 'end' | 'all'} [options.mode] - Specifies the selection mode,
   * which can be one of the following: `start` to move the cursor to the beginning
   * of the cell's content, `end` to move it to the end, or `all` to extend the
   * selection over the entire cell's content.
   * @returns {boolean} `true` if the action was successful, `false` otherwise.
   */
  downward(editor, options = {}) {
    if (!editor.selection) {
      return false;
    }
    const [table, td] = Editor5.nodes(editor, {
      match: isOfType(editor, "table", "th", "td"),
      at: Range.end(editor.selection)
    });
    if (!table || !td) {
      return false;
    }
    const [, tablePath] = table;
    const [, tdPath] = td;
    const m = filledMatrix(editor, { at: tablePath });
    let next;
    let indexY = 0;
    outer:
      for (let x = 0; x < m.length; x++) {
        for (indexY = 0; indexY < m[x].length; indexY++) {
          const [[, path2], { ltr: colSpan, btt: rowSpan }] = m[x][indexY];
          if (rowSpan === 1 && Path.equals(path2, tdPath)) {
            next = m[x + 1];
            break outer;
          }
          indexY += colSpan - 1;
        }
      }
    if (!next || !next[indexY]) {
      if (Node4.has(editor, Path.next(tablePath))) {
        Transforms.select(editor, Editor5.end(editor, Path.next(tablePath)));
        return true;
      }
      return false;
    }
    const [[, path]] = next[indexY];
    options.mode === "all" ? Transforms.select(editor, path) : Transforms.select(
      editor,
      options.mode === "start" ? Editor5.start(editor, path) : Editor5.end(editor, path)
    );
    return true;
  },
  /**
   * Moves the cursor to the cell next to the current selection.
   * @param {'start' | 'end' | 'all'} [options.mode] - Specifies the selection mode,
   * which can be one of the following: `start` to move the cursor to the beginning
   * of the cell's content, `end` to move it to the end, or `all` to extend the
   * selection over the entire cell's content.
   * @returns {boolean} `true` if the action was successful, `false` otherwise.
   */
  forward(editor, options = {}) {
    if (!editor.selection) {
      return false;
    }
    const [table, td] = Editor5.nodes(editor, {
      match: isOfType(editor, "table", "th", "td"),
      at: Range.end(editor.selection)
    });
    if (!table || !td) {
      return false;
    }
    const [, tablePath] = table;
    const [, tdPath] = td;
    let foundTd = false;
    let nextPath;
    outer:
      for (const tr of matrix(editor, { at: tablePath })) {
        for (const [, path] of tr) {
          if (!foundTd) {
            foundTd = Path.equals(path, tdPath);
            continue;
          }
          nextPath = path;
          break outer;
        }
      }
    if (!nextPath) {
      if (Node4.has(editor, Path.next(tablePath))) {
        Transforms.select(editor, Editor5.end(editor, Path.next(tablePath)));
        return true;
      }
      return false;
    }
    options.mode === "all" ? Transforms.select(editor, nextPath) : Transforms.select(
      editor,
      options.mode === "start" ? Editor5.start(editor, nextPath) : Editor5.end(editor, nextPath)
    );
    return true;
  },
  /**
   * Moves the cursor to the cell before the current selection.
   * @param {'start' | 'end' | 'all'} [options.mode] - Specifies the selection mode,
   * which can be one of the following: `start` to move the cursor to the beginning
   * of the cell's content, `end` to move it to the end, or `all` to extend the
   * selection over the entire cell's content.
   * @returns {boolean} `true` if the action was successful, `false` otherwise.
   */
  backward(editor, options = {}) {
    if (!editor.selection) {
      return false;
    }
    const [table, td] = Editor5.nodes(editor, {
      match: isOfType(editor, "table", "th", "td"),
      at: Range.start(editor.selection)
    });
    if (!table || !td) {
      return false;
    }
    const [, tablePath] = table;
    const [, tdPath] = td;
    let foundTd = false;
    let previousPath;
    outer:
      for (const tr of matrix(editor, { at: tablePath, reverse: true })) {
        for (const [, path] of tr) {
          if (!foundTd) {
            foundTd = Path.equals(path, tdPath);
            continue;
          }
          previousPath = path;
          break outer;
        }
      }
    if (!previousPath) {
      if (Path.hasPrevious(tablePath)) {
        Transforms.select(editor, Editor5.end(editor, Path.previous(tablePath)));
        return true;
      }
      return false;
    }
    options.mode === "all" ? Transforms.select(editor, previousPath) : Transforms.select(
      editor,
      options.mode === "start" ? Editor5.start(editor, previousPath) : Editor5.end(editor, previousPath)
    );
    return true;
  },
  /**
   * Checks if the selection is positioned on an edge within a td or th.
   * @param {'start' | 'end' | 'top' | 'bottom'} edge - Specifies which edge to check:
   * - `start`: checks if the cursor is positioned at the start of the cell's content
   * - `end`: checks if the cursor is positioned at the end of the cell's content
   * - `top`: checks if the cursor is positioned at the first block of the cell's content
   * - `bottom`: checks if the cursor is positioned at the last block of the cell's content
   * @returns {boolean} `true` if the cursor is on the specified edge, `false` otherwise.
   */
  isOnEdge(editor, edge) {
    const { selection } = editor;
    if (!selection) {
      return false;
    }
    const point = edge === "start" || edge === "top" ? Range.start(selection) : Range.end(selection);
    const [td] = Editor5.nodes(editor, {
      match: isOfType(editor, "th", "td"),
      at: point
    });
    if (!td) {
      return false;
    }
    const [, tdPath] = td;
    const endPoint = Editor5.end(editor, tdPath);
    const startPoint = Editor5.start(editor, tdPath);
    switch (edge) {
      case "start":
        return Point2.equals(point, startPoint);
      case "end":
        return Point2.equals(point, endPoint);
      case "top":
        return Path.equals(point.path, startPoint.path);
      case "bottom":
        return Path.equals(point.path, endPoint.path);
      default:
        return false;
    }
  },
  /**
   * Checks if the cursor is in the first cell of the table.
   * @param {boolean} [options.reverse] - If true, checks the table
   * in reverse order to determine if the cell is last in table.
   * @returns {boolean} `true` if the cursor is in the first cell, otherwise `false`.
   */
  isInFirstCell(editor, options = {}) {
    if (!editor.selection) {
      return false;
    }
    const [table, td] = Editor5.nodes(editor, {
      match: isOfType(editor, "table", "th", "td"),
      reverse: options.reverse
    });
    if (!table || !td) {
      return false;
    }
    const [, tablePath] = table;
    const [, tdPath] = td;
    const [first] = Editor5.nodes(editor, {
      match: isOfType(editor, "th", "td"),
      reverse: options.reverse,
      at: tablePath
    });
    return Path.equals(first[1], tdPath);
  },
  /**
   * Checks if the cursor is in the last cell of the table
   * @returns {boolean} `true` if the cursor is in the last cell, otherwise `false`.
   */
  isInLastCell(editor) {
    return TableCursor.isInFirstCell(editor, { reverse: true });
  },
  /**
   * Checks if the cursor is in the first tr of the table.
   * @param {boolean} [options.reverse] - If true, checks the table
   * in reverse order to determine if the tr is last in table.
   * @returns {boolean} `true` if the cursor is in the first row, otherwise `false`.
   */
  isInFirstRow(editor, options = {}) {
    if (!editor.selection) {
      return false;
    }
    const [table, tr] = Editor5.nodes(editor, {
      match: isOfType(editor, "table", "tr"),
      reverse: options.reverse
    });
    if (!table || !tr) {
      return false;
    }
    const [, tablePath] = table;
    const [, trPath] = tr;
    const [first] = Editor5.nodes(editor, {
      match: isOfType(editor, "tr"),
      reverse: options.reverse,
      at: tablePath
    });
    return Path.equals(first[1], trPath);
  },
  /**
   * Checks if the cursor is in the last row of the table
   * @returns {boolean} `true` if the cursor is in the first row, otherwise `false`.
   */
  isInLastRow(editor) {
    return TableCursor.isInFirstRow(editor, { reverse: true });
  },
  /**
   * Retrieves a matrix representing the selected cells within a table.
   * @returns {NodeEntry<T>[][]} A matrix containing the selected cells.
   */
  *selection(editor) {
    const editorOptions = EDITOR_TO_WITH_TABLE_OPTIONS.get(editor);
    if (!(editorOptions == null ? void 0 : editorOptions.withSelection)) {
      throw new Error(
        "The `selection` command must be used with the `withSelection` option."
      );
    }
    const matrix2 = EDITOR_TO_SELECTION.get(editor);
    for (let x = 0; matrix2 && x < matrix2.length; x++) {
      const cells = [];
      for (let y = 0; y < matrix2[x].length; y++) {
        const [entry, { ltr: colSpan, ttb }] = matrix2[x][y];
        ttb === 1 && cells.push(entry);
        y += colSpan - 1;
      }
      yield cells;
    }
  },
  /** Clears the selection from the table */
  unselect(editor) {
    const editorOptions = EDITOR_TO_WITH_TABLE_OPTIONS.get(editor);
    if (!(editorOptions == null ? void 0 : editorOptions.withSelection)) {
      throw new Error(
        "The `unselect` command must be used with the `withSelection` option."
      );
    }
    const matrix2 = EDITOR_TO_SELECTION.get(editor);
    if (!(matrix2 == null ? void 0 : matrix2.length)) {
      return;
    }
    for (let x = 0; x < matrix2.length; x++) {
      for (let y = 0; y < matrix2[x].length; y++) {
        const [[, path], { ltr: colSpan, ttb }] = matrix2[x][y];
        y += colSpan - 1;
        if (ttb > 1) {
          continue;
        }
        const noop = {
          type: "move_node",
          newPath: path,
          path
        };
        Transforms.transform(editor, noop);
      }
    }
    EDITOR_TO_SELECTION_SET.delete(editor);
    EDITOR_TO_SELECTION.delete(editor);
  },
  /**
   * Checks whether a given cell is part of the current table selection.
   * @returns {boolean} - Returns true if the cell is selected, otherwise false.
   */
  isSelected(editor, element) {
    const editorOptions = EDITOR_TO_WITH_TABLE_OPTIONS.get(editor);
    if (!(editorOptions == null ? void 0 : editorOptions.withSelection)) {
      throw new Error(
        "The `isSelected` command must be used with the `withSelection` option."
      );
    }
    const selectedElements = EDITOR_TO_SELECTION_SET.get(editor);
    if (!selectedElements) {
      return false;
    }
    return selectedElements.has(element);
  }
};

// src/options.ts
var DEFAULT_WITH_TABLE_OPTIONS = {
  blocks: {
    td: "table-cell",
    th: "header-cell",
    content: "paragraph",
    tr: "table-row",
    table: "table",
    tbody: "table-body",
    tfoot: "table-footer",
    thead: "table-head"
  },
  withDelete: true,
  withFragments: true,
  withInsertText: true,
  withNormalization: true,
  withSelection: true,
  withSelectionAdjustment: true
};
var DEFAULT_INSERT_TABLE_OPTIONS = {
  rows: 2,
  cols: 2
};

// src/table-editor.ts
import { Editor as Editor6, Node as Node5, Path as Path2, Transforms as Transforms2 } from "slate";
var TableEditor = {
  /**
   * Inserts a table at the specified location with the specified number of
   * rows and columns. If no location is specified it will be inserted at the current
   * selection.
   * @param options The `rows` and `cols` specify the number of rows and
   * columns in the table, if not provided, they default to 2. The `at`
   * property can be used to optionally specifiy the location at which
   * to insert the table.
   * @returns void
   */
  insertTable(editor, options = {}) {
    const editorOptions = EDITOR_TO_WITH_TABLE_OPTIONS.get(editor);
    if (!editorOptions) {
      return;
    }
    const {
      blocks: { content, table, tbody, td, tr }
    } = editorOptions;
    const { rows, cols, at } = __spreadValues(__spreadValues({}, DEFAULT_INSERT_TABLE_OPTIONS), options);
    if (TableCursor.isInTable(editor, { at })) {
      return;
    }
    const clamp = (n) => n < 1 ? 1 : n;
    Transforms2.insertNodes(
      editor,
      {
        type: table,
        children: [
          {
            type: tbody,
            children: Array.from({ length: clamp(rows) }).map(() => ({
              type: tr,
              children: Array.from({ length: clamp(cols) }).map(() => ({
                type: td,
                children: [
                  {
                    type: content,
                    children: [{ text: "" }]
                  }
                ]
              }))
            }))
          }
        ]
      },
      { at }
    );
  },
  /**
   * Removes a table at the specified location. If no location is specified
   * it will remove the table at the current selection.
   * @returns void
   */
  removeTable(editor, options = {}) {
    const [table] = Editor6.nodes(editor, {
      match: isOfType(editor, "table"),
      at: options.at
    });
    if (!table) {
      return;
    }
    const [, path] = table;
    Transforms2.removeNodes(editor, { at: path });
  },
  /**
   * Inserts a new row at the specified location. If no location
   * is specified it will insert the row at the current selection.
   * @param options The `at` specifies the location of the base row
   * on which the new row will be inserted. Depending on the `before`
   * property the row will be inserted before or after the base row.
   * @returns void
   */
  insertRow(editor, options = {}) {
    const editorOptions = EDITOR_TO_WITH_TABLE_OPTIONS.get(editor);
    if (!editorOptions) {
      return;
    }
    const [table, currentSection, currentTr, currentTd] = Editor6.nodes(editor, {
      match: isOfType(
        editor,
        "table",
        // current table
        "thead",
        // current section
        "tbody",
        "tfoot",
        "tr",
        // current row
        "td",
        // current cell
        "th"
      ),
      at: options.at
    });
    if (!table || !currentSection || !currentTr || !currentTd) {
      return;
    }
    const matrix2 = filledMatrix(editor, { at: options.at });
    let trIndex = 0;
    outer:
      for (let x = 0; x < matrix2.length; x++) {
        const [, currentTdPath] = currentTd;
        for (let y = 0; y < matrix2[x].length; y++) {
          const [[, path], { btt }] = matrix2[x][y];
          if (!Path2.equals(currentTdPath, path)) {
            continue;
          }
          trIndex = x;
          if (options.before || btt < 2) {
            break outer;
          }
        }
      }
    const [...tableRows] = Editor6.nodes(editor, {
      match: isOfType(editor, "tr"),
      at: table[1]
    });
    Editor6.withoutNormalizing(editor, () => {
      const destIndex = options.before ? trIndex - 1 : trIndex + 1;
      const isWithinBounds = destIndex >= 0 && destIndex < matrix2.length;
      let increasedRowspan = 0;
      for (let y = 0; isWithinBounds && y < matrix2[destIndex].length; y++) {
        const [[element, path], { ltr, ttb, btt }] = matrix2[destIndex][y];
        const rowSpan = element.rowSpan || 1;
        if (options.before ? btt > 1 : ttb > 1) {
          increasedRowspan += ltr;
          Transforms2.setNodes(
            editor,
            {
              rowSpan: rowSpan + 1
            },
            { at: path }
          );
        }
        y += ltr - 1;
      }
      const { length: colLen } = isWithinBounds ? matrix2[destIndex] : matrix2[0];
      const { blocks } = editorOptions;
      const [, currentPath] = tableRows[trIndex];
      const [section] = currentSection;
      Transforms2.insertNodes(
        editor,
        {
          type: blocks.tr,
          children: Array.from({ length: colLen - increasedRowspan }).map(
            () => ({
              type: section.type === blocks.thead ? blocks.th : blocks.td,
              children: [
                {
                  type: blocks.content,
                  children: [{ text: "" }]
                }
              ]
            })
          )
        },
        {
          at: options.before ? currentPath : Path2.next(currentPath)
        }
      );
    });
  },
  /**
   * Removes the row at the specified location. If no location is specified
   * it will remove the row at the current selection.
   * @returns void
   */
  removeRow(editor, options = {}) {
    const editorOptions = EDITOR_TO_WITH_TABLE_OPTIONS.get(editor);
    if (!editorOptions) {
      return;
    }
    const [table, section, tr, td] = Editor6.nodes(editor, {
      match: isOfType(
        editor,
        "table",
        // table
        "thead",
        // section
        "tbody",
        "tfoot",
        "tr",
        // row
        "td",
        // cell
        "th"
      ),
      at: options.at
    });
    if (!table || !section || !tr || !td) {
      return;
    }
    const [, tablePath] = table;
    const [, sectionPath] = section;
    const [, trPath] = tr;
    const [, tdPath] = td;
    const [, globalSibling] = Editor6.nodes(editor, {
      match: isOfType(editor, "tr"),
      at: tablePath
    });
    if (!globalSibling) {
      return Transforms2.removeNodes(editor, {
        at: tablePath
      });
    }
    const matrix2 = filledMatrix(editor, { at: options.at });
    let trIndex = 0;
    out:
      for (let x = 0; x < matrix2.length; x++) {
        for (let y = 0; y < matrix2[x].length; y++) {
          const [[, path], { ltr: colSpan }] = matrix2[x][y];
          if (Path2.equals(tdPath, path)) {
            trIndex = x;
            break out;
          }
          y += colSpan - 1;
        }
      }
    let hasRowspan = false;
    const toReduce = [];
    for (let i = 0; i < matrix2[trIndex].length; i++) {
      const [entry, { ltr: colSpan, ttb, btt }] = matrix2[trIndex][i];
      if (ttb === 1 && btt > 1) {
        hasRowspan = true;
      }
      if (ttb > 1 || btt > 1) {
        toReduce.push(entry);
      }
      i += colSpan - 1;
    }
    const toAdd = [];
    const next = matrix2[trIndex + 1];
    for (let i = 0; hasRowspan && i < (next == null ? void 0 : next.length); i++) {
      const [entry, { ltr: colSpan, ttb }] = next[i];
      if (ttb > 2) {
        continue;
      }
      toAdd.push(entry);
      i += colSpan - 1;
    }
    Editor6.withoutNormalizing(editor, () => {
      for (const [{ rowSpan = 1 }, path] of toReduce) {
        Transforms2.setNodes(
          editor,
          { rowSpan: rowSpan - 1 },
          { at: path }
        );
      }
      if (hasRowspan) {
        const { blocks } = editorOptions;
        Transforms2.mergeNodes(editor, {
          match: isOfType(editor, "tr"),
          at: Path2.next(trPath)
        });
        Transforms2.insertNodes(
          editor,
          {
            type: blocks.tr,
            children: toAdd.map((entry) => {
              const [element] = entry;
              if (toReduce.includes(entry)) {
                const _a = element, { rowSpan = 1 } = _a, rest = __objRest(_a, ["rowSpan"]);
                return __spreadProps(__spreadValues({}, rest), { rowSpan: rowSpan === 1 ? 1 : rowSpan - 1 });
              }
              return element;
            })
          },
          { at: Path2.next(trPath) }
        );
      }
      const [, sibling] = Editor6.nodes(editor, {
        match: isOfType(editor, "tr"),
        at: sectionPath
      });
      return Transforms2.removeNodes(editor, {
        // removes table section if there is no sibling in it
        at: sibling ? trPath : sectionPath
      });
    });
  },
  /**
   * Inserts a new column at the specified location. If no location
   * is specified it will insert the column at the current selection.
   * @returns void
   */
  insertColumn(editor, options = {}) {
    const editorOptions = EDITOR_TO_WITH_TABLE_OPTIONS.get(editor);
    if (!editorOptions) {
      return;
    }
    const [table, td] = Editor6.nodes(editor, {
      match: isOfType(
        editor,
        "table",
        // table
        "td",
        // cell
        "th"
      ),
      at: options.at
    });
    if (!table || !td) {
      return;
    }
    const [, tdPath] = td;
    const matrix2 = filledMatrix(editor, { at: options.at });
    let tdIndex = 0;
    out:
      for (let x = 0; x < matrix2.length; x++) {
        for (let y = 0; y < matrix2[x].length; y++) {
          const [[, path]] = matrix2[x][y];
          if (Path2.equals(tdPath, path)) {
            tdIndex = y;
            if (options.before) {
              break out;
            }
          }
        }
      }
    Editor6.withoutNormalizing(editor, () => {
      const { blocks } = editorOptions;
      outer:
        for (let x = 0; x < matrix2.length; x++) {
          const [[{ colSpan = 1 }, path], { ltr, rtl, ttb, btt }] = matrix2[x][tdIndex];
          if (options.before ? rtl > 1 : ltr > 1) {
            Transforms2.setNodes(
              editor,
              { colSpan: colSpan + 1 },
              { at: path }
            );
            x += btt - 1;
            continue;
          }
          const [[section]] = Editor6.nodes(editor, {
            match: isOfType(editor, "thead", "tbody", "tfoot"),
            at: path
          });
          const insertTd = (path2) => Transforms2.insertNodes(
            editor,
            {
              type: section.type === blocks.thead ? blocks.th : blocks.td,
              children: [
                {
                  type: blocks.content,
                  children: [{ text: "" }]
                }
              ]
            },
            { at: path2 }
          );
          if (ttb === 1) {
            insertTd(options.before ? path : Path2.next(path));
            continue;
          }
          for (let y = tdIndex; y >= 0; y--) {
            const [[, path2], { ttb: ttb2 }] = matrix2[x][y];
            if (ttb2 !== 1) {
              continue;
            }
            insertTd(Path2.next(path2));
            continue outer;
          }
          let index = 0;
          for (const [, path2] of Editor6.nodes(editor, {
            match: isOfType(editor, "tr"),
            at: table[1]
          })) {
            if (index !== x) {
              index++;
              continue;
            }
            insertTd(path2.concat(0));
            continue outer;
          }
        }
    });
  },
  /**
   * Removes the column at the specified location. If no location is specified
   * it will remove the column at the current selection.
   * @returns void
   */
  removeColumn(editor, options = {}) {
    const [table, td] = Editor6.nodes(editor, {
      match: isOfType(
        editor,
        "table",
        // table
        "td",
        // cell
        "th"
      ),
      at: options.at
    });
    if (!table || !td) {
      return;
    }
    const [, tablePath] = table;
    const [, tdPath] = td;
    const matrix2 = filledMatrix(editor, { at: options.at });
    const [, sibling] = matrix2[0];
    if (!sibling) {
      return Transforms2.removeNodes(editor, {
        at: tablePath
      });
    }
    let tdIndex = 0;
    out:
      for (let x = 0; x < matrix2.length; x++) {
        for (let y = 0; y < matrix2[x].length; y++) {
          const [[, path], { ltr: colSpan }] = matrix2[x][y];
          if (Path2.equals(tdPath, path)) {
            tdIndex = y;
            break out;
          }
          y += colSpan - 1;
        }
      }
    Editor6.withoutNormalizing(editor, () => {
      for (let x = matrix2.length - 1; x >= 0; x--) {
        const [[{ colSpan = 1 }, path], { ltr, rtl, ttb }] = matrix2[x][tdIndex];
        if (ttb > 1) {
          continue;
        }
        let hasSibling = false;
        for (let y = 0; y < matrix2[x].length; y++) {
          if (y === tdIndex) {
            continue;
          }
          const [[, siblingPath], { ltr: colSpan2 }] = matrix2[x][y];
          if (Path2.isSibling(path, siblingPath)) {
            hasSibling = true;
            break;
          }
          y += colSpan2 - 1;
        }
        if (!hasSibling) {
          TableEditor.removeRow(editor, { at: path });
          continue;
        }
        ltr === 1 && rtl === 1 ? Transforms2.removeNodes(editor, { at: path }) : Transforms2.setNodes(
          editor,
          { colSpan: colSpan - 1 },
          { at: path }
        );
        x -= ttb - 1;
      }
    });
  },
  /**
   * Checks if the current selection can be merged. Merging is not possible when any of the following conditions are met:
   * - The selection is empty.
   * - The selection is not within the same "thead", "tbody," or "tfoot" section.
   * @returns {boolean} `true` if the selection can be merged, otherwise `false`.
   */
  canMerge(editor) {
    const matrix2 = EDITOR_TO_SELECTION.get(editor);
    if (!matrix2 || !matrix2.length) {
      return false;
    }
    const [[, lastPath]] = matrix2[matrix2.length - 1][matrix2[matrix2.length - 1].length - 1];
    const [[, firstPath]] = matrix2[0][0];
    if (!hasCommon(editor, [firstPath, lastPath], "thead", "tbody", "tfoot")) {
      return false;
    }
    return true;
  },
  /**
   * Merges the selected cells in the table.
   * @returns void
   */
  merge(editor) {
    if (!TableEditor.canMerge(editor)) {
      return;
    }
    const selection = EDITOR_TO_SELECTION.get(editor);
    if (!selection || !selection.length) {
      return;
    }
    const [[, basePath]] = selection[0][0];
    const [[, lastPath]] = Node5.children(editor, basePath, { reverse: true });
    const matrix2 = filledMatrix(editor, { at: basePath });
    Editor6.withoutNormalizing(editor, () => {
      let rowSpan = 0;
      let colSpan = 0;
      for (let x = selection.length - 1; x >= 0; x--, rowSpan++) {
        colSpan = 0;
        for (let y = selection[x].length - 1; y >= 0; y--, colSpan++) {
          const [[, path], { rtl: colspan, ttb }] = selection[x][y];
          y -= colspan - 1;
          colSpan += colspan - 1;
          if (Path2.equals(basePath, path) || ttb > 1) {
            continue;
          }
          for (const [, childPath] of Node5.children(editor, path, { reverse: true })) {
            Transforms2.moveNodes(editor, {
              to: Path2.next(lastPath),
              at: childPath
            });
          }
          const [[, trPath]] = Editor6.nodes(editor, {
            match: isOfType(editor, "tr"),
            at: path
          });
          const [, sibling] = Node5.children(editor, trPath);
          if (sibling) {
            Transforms2.removeNodes(editor, { at: path });
            continue;
          }
          let trIndex = 0;
          out:
            for (let i = 0; i < matrix2.length; i++) {
              for (let j = 0; j < matrix2[i].length; j++) {
                const [[, tdPath]] = matrix2[i][j];
                if (Path2.equals(tdPath, path)) {
                  trIndex = i;
                  break out;
                }
              }
            }
          for (let y2 = 0; y2 < matrix2[trIndex].length; y2++) {
            const [[, tdPath], { ttb: ttb2, ltr }] = matrix2[trIndex][y2];
            y2 += ltr - 1;
            if (ttb2 === 1) {
              continue;
            }
            const [element] = Editor6.node(editor, tdPath);
            if (isElement(element)) {
              const { rowSpan: rowSpan2 = 1 } = element;
              Transforms2.setNodes(
                editor,
                { rowSpan: rowSpan2 - 1 },
                { at: tdPath }
              );
            }
          }
          rowSpan--;
          Transforms2.removeNodes(editor, { at: trPath });
        }
      }
      if (selection.length === matrix2.length) {
        colSpan = 1;
      }
      Transforms2.setNodes(
        editor,
        { rowSpan, colSpan },
        { at: basePath }
      );
    });
  },
  /**
   * Splits either the cell at the current selection or a specified location. If a range
   * selection is present, all cells within the range will be split.
   * @param {Location} [options.at] - Splits the cell at the specified location. If no
   * location is specified it will split the cell at the current selection
   * @param {boolean} [options.all] - If true, splits all cells in the table
   * @returns void
   */
  split(editor, options = {}) {
    const editorOptions = EDITOR_TO_WITH_TABLE_OPTIONS.get(editor);
    if (!editorOptions) {
      return;
    }
    const [table, td] = Editor6.nodes(editor, {
      match: isOfType(editor, "table", "th", "td"),
      at: options.at
    });
    if (!table || !td) {
      return;
    }
    const selection = EDITOR_TO_SELECTION.get(editor) || [];
    const matrix2 = filledMatrix(editor, { at: options.at });
    const { blocks } = editorOptions;
    Editor6.withoutNormalizing(editor, () => {
      for (let x = matrix2.length - 1; x >= 0; x--) {
        for (let y = matrix2[x].length - 1; y >= 0; y--) {
          const [[, path], context] = matrix2[x][y];
          const { ltr: colSpan, rtl, btt: rowSpan, ttb } = context;
          if (rtl > 1) {
            y -= rtl - 2;
            continue;
          }
          if (ttb > 1) {
            continue;
          }
          if (rowSpan === 1 && colSpan === 1) {
            continue;
          }
          let found = !!options.all;
          if (selection.length) {
            outer:
              for (let i = 0; !options.all && i < selection.length; i++) {
                for (let j = 0; j < selection[i].length; j++) {
                  const [[, tdPath]] = selection[i][j];
                  if (Path2.equals(tdPath, path)) {
                    found = true;
                    break outer;
                  }
                }
              }
          } else {
            const [, tdPath] = td;
            if (Path2.equals(tdPath, path)) {
              found = true;
            }
          }
          if (!found) {
            continue;
          }
          const [[section]] = Editor6.nodes(editor, {
            match: isOfType(editor, "thead", "tbody", "tfoot"),
            at: path
          });
          out:
            for (let r = 1; r < rowSpan; r++) {
              for (let i = y; i >= 0; i--) {
                const [[, path2], { ttb: ttb2 }] = matrix2[x + r][i];
                if (ttb2 !== 1) {
                  continue;
                }
                for (let c = 0; c < colSpan; c++) {
                  Transforms2.insertNodes(
                    editor,
                    {
                      type: section.type === blocks.thead ? blocks.th : blocks.td,
                      children: [
                        {
                          type: blocks.content,
                          children: [{ text: "" }]
                        }
                      ]
                    },
                    { at: Path2.next(path2) }
                  );
                }
                continue out;
              }
              for (let i = y; i < matrix2[x].length; i++) {
                const [[, path2], { ttb: ttb2 }] = matrix2[x + r][i];
                if (ttb2 !== 1) {
                  continue;
                }
                for (let c = 0; c < colSpan; c++) {
                  Transforms2.insertNodes(
                    editor,
                    {
                      type: section.type === blocks.thead ? blocks.th : blocks.td,
                      children: [
                        {
                          type: blocks.content,
                          children: [{ text: "" }]
                        }
                      ]
                    },
                    { at: [...Path2.parent(path2), 0] }
                  );
                }
                continue out;
              }
            }
          for (let c = 1; c < colSpan; c++) {
            Transforms2.insertNodes(
              editor,
              {
                type: section.type === blocks.thead ? blocks.th : blocks.td,
                children: [
                  {
                    type: blocks.content,
                    children: [{ text: "" }]
                  }
                ]
              },
              { at: Path2.next(path) }
            );
          }
          Transforms2.setNodes(
            editor,
            { rowSpan: 1, colSpan: 1 },
            { at: path }
          );
        }
      }
    });
  }
};

// src/with-delete.ts
import { Editor as Editor7, Node as Node6, Path as Path3, Point as Point3, Range as Range2, Transforms as Transforms3 } from "slate";
function withDelete(editor, { withDelete: withDelete2, withSelection: withSelection2, blocks }) {
  if (!withDelete2) {
    return editor;
  }
  const { deleteBackward, deleteForward, deleteFragment } = editor;
  editor.deleteBackward = (unit) => {
    const { selection } = editor;
    if (!selection || Range2.isExpanded(selection)) {
      return deleteBackward(unit);
    }
    const [td] = Editor7.nodes(editor, {
      match: isOfType(editor, "th", "td"),
      at: selection
    });
    const before = Editor7.before(editor, selection, { unit });
    const [tdBefore] = before ? Editor7.nodes(editor, {
      match: isOfType(editor, "th", "td"),
      at: before
    }) : [void 0];
    if (!td && !tdBefore) {
      return deleteBackward(unit);
    }
    if (!td && tdBefore && before) {
      return Transforms3.select(editor, before);
    }
    const [, tdPath] = td;
    const start = Editor7.start(editor, tdPath);
    if (Point3.equals(selection.anchor, start)) {
      return;
    }
    deleteBackward(unit);
  };
  editor.deleteForward = (unit) => {
    const { selection } = editor;
    if (!selection || Range2.isExpanded(selection)) {
      return deleteForward(unit);
    }
    const [td] = Editor7.nodes(editor, {
      match: isOfType(editor, "th", "td"),
      at: selection
    });
    const after = Editor7.after(editor, selection, { unit });
    const [tdAfter] = after ? Editor7.nodes(editor, { match: isOfType(editor, "th", "td"), at: after }) : [void 0];
    if (!td && !tdAfter) {
      return deleteForward(unit);
    }
    if (!td && tdAfter && after) {
      return Transforms3.select(editor, after);
    }
    const [, tdPath] = td;
    const end = Editor7.end(editor, tdPath);
    if (Point3.equals(selection.anchor, end)) {
      return;
    }
    deleteForward(unit);
  };
  editor.deleteFragment = (options) => {
    const { selection } = editor;
    if (!selection || Range2.isCollapsed(selection)) {
      return deleteFragment(options);
    }
    const [startPoint, endPoint] = Range2.edges(selection);
    const edges = [startPoint.path, endPoint.path];
    if (!hasCommon(editor, edges, "table") || hasCommon(editor, edges, "th", "td")) {
      return deleteFragment(options);
    }
    const isBackward = (options == null ? void 0 : options.direction) === "backward";
    const selected = EDITOR_TO_SELECTION.get(editor);
    Editor7.withoutNormalizing(editor, () => {
      if (withSelection2 && selected && selected.length) {
        const [[, lastPath2]] = selected[selected.length - 1][selected[selected.length - 1].length - 1];
        const [[, firstPath2]] = selected[0][0];
        for (let x = selected.length - 1; x >= 0; x--) {
          for (let y = selected[x].length - 1; y >= 0; y--) {
            const [[, path], { rtl, ttb }] = selected[x][y];
            if (rtl > 1 || ttb > 1) {
              continue;
            }
            for (const [, childPath] of Node6.children(editor, path, {
              reverse: true
            })) {
              Transforms3.removeNodes(editor, { at: childPath });
            }
            Transforms3.insertNodes(
              editor,
              {
                type: blocks.content,
                children: [{ text: "" }]
              },
              { at: [...path, 0] }
            );
          }
        }
        Transforms3.select(editor, isBackward ? firstPath2 : lastPath2);
        return;
      }
      let firstPath = null;
      let lastPath = null;
      for (const [, path] of Editor7.nodes(editor, {
        match: isOfType(editor, "th", "td"),
        at: selection,
        reverse: true
      })) {
        for (const [, childPath] of Node6.children(editor, path, {
          reverse: true
        })) {
          Transforms3.removeNodes(editor, { at: childPath });
        }
        firstPath = [...path, 0];
        lastPath = !lastPath ? [...path, 0] : lastPath;
        Transforms3.insertNodes(
          editor,
          {
            type: blocks.content,
            children: [{ text: "" }]
          },
          { at: [...path, 0] }
        );
      }
      if (isBackward) {
        Transforms3.select(editor, Path3.isPath(firstPath) ? firstPath : []);
        return;
      }
      Transforms3.select(editor, Path3.isPath(lastPath) ? lastPath : []);
    });
  };
  return editor;
}

// src/with-fragments.ts
import { Node as Node7 } from "slate";
function withFragments(editor, { withFragments: withFragments2 }) {
  if (!withFragments2) {
    return editor;
  }
  const { getFragment } = editor;
  editor.getFragment = () => {
    const newFragment = [];
    for (const fragment of getFragment()) {
      if (!isOfType(editor, "table")(fragment, [])) {
        newFragment.push(fragment);
        continue;
      }
      for (const [node] of Node7.nodes(fragment, {
        pass: ([node2]) => isOfType(editor, "content")(node2, [])
      })) {
        if (isOfType(editor, "content")(node, [])) {
          newFragment.push(node);
        }
      }
    }
    return newFragment;
  };
  return editor;
}

// src/with-insert-text.ts
import { Range as Range3, Transforms as Transforms4 } from "slate";
function withInsertText(editor, { withInsertText: withInsertText2 }) {
  if (!withInsertText2) {
    return editor;
  }
  const { insertText, insertBreak, insertSoftBreak } = editor;
  editor.insertText = (text, options) => {
    if (shouldCollapse(editor)) {
      Transforms4.collapse(editor, { edge: "focus" });
    }
    insertText(text, options);
  };
  editor.insertBreak = () => {
    if (shouldCollapse(editor)) {
      Transforms4.collapse(editor, { edge: "focus" });
    }
    insertBreak();
  };
  editor.insertSoftBreak = () => {
    if (shouldCollapse(editor)) {
      Transforms4.collapse(editor, { edge: "focus" });
    }
    insertSoftBreak();
  };
  return editor;
}
function shouldCollapse(editor) {
  const { selection } = editor;
  if (!selection || Range3.isCollapsed(selection)) {
    return false;
  }
  const [startPoint, endPoint] = Range3.edges(selection);
  return TableCursor.isInTable(editor, { at: selection }) && !hasCommon(editor, [startPoint.path, endPoint.path], "th", "td");
}

// src/normalization/normalize-attributes.ts
import { Transforms as Transforms5 } from "slate";
function normalizeAttributes(editor, { blocks: { td, th } }) {
  const { normalizeNode } = editor;
  editor.normalizeNode = (entry, options) => {
    const [node, path] = entry;
    if (isElement(node) && [th, td].includes(node.type)) {
      const { rowSpan, colSpan } = node;
      if (rowSpan === 1 || colSpan === 1) {
        const attributes = ["rowSpan", "colSpan"];
        return Transforms5.unsetNodes(
          editor,
          attributes.filter((attr) => node[attr] === 1),
          { at: path }
        );
      }
    }
    normalizeNode(entry, options);
  };
  return editor;
}

// src/normalization/normalize-content.ts
import { Node as Node8, Transforms as Transforms6 } from "slate";
function normalizeContent(editor, { blocks }) {
  const { table, thead, tbody, tfoot, tr, th, td, content } = blocks;
  const FORBIDDEN = [table, thead, tbody, tfoot, tr, th, td, content];
  const { normalizeNode } = editor;
  editor.normalizeNode = (entry, options) => {
    const [node, path] = entry;
    if (isElement(node) && node.type === content) {
      for (const [child, childPath] of Node8.children(editor, path)) {
        if (isElement(child) && FORBIDDEN.includes(child.type)) {
          return Transforms6.unwrapNodes(editor, { at: childPath });
        }
      }
    }
    normalizeNode(entry, options);
  };
  return editor;
}

// src/normalization/normalize-sections.ts
import { Node as Node9, Transforms as Transforms7 } from "slate";
function normalizeSections(editor, { blocks: { thead, tbody, tfoot, tr } }) {
  const { normalizeNode } = editor;
  editor.normalizeNode = (entry, options) => {
    const [node, path] = entry;
    if (isElement(node) && [thead, tbody, tfoot].includes(node.type)) {
      for (const [child, childPath] of Node9.children(editor, path)) {
        if (!isElement(child) || child.type !== tr) {
          return Transforms7.wrapNodes(
            editor,
            {
              type: tr,
              children: [child]
            },
            { at: childPath }
          );
        }
      }
    }
    normalizeNode(entry, options);
  };
  return editor;
}

// src/normalization/normalize-table.ts
import { Editor as Editor13, Node as Node10, Path as Path4, Transforms as Transforms8 } from "slate";
function normalizeTable(editor, { blocks: { table, thead, tbody, tfoot } }) {
  const { normalizeNode } = editor;
  editor.normalizeNode = (entry, options) => {
    const [node, path] = entry;
    if (isElement(node) && node.type === table) {
      for (const [child, childPath] of Node10.children(editor, path)) {
        if (isElement(child) && [thead, tbody, tfoot].includes(child.type)) {
          continue;
        }
        const tbodyEntry = immediateTbody(editor, path);
        if (!tbodyEntry) {
          return Transforms8.wrapNodes(
            editor,
            {
              type: tbody,
              children: [child]
            },
            { at: childPath }
          );
        }
        const [tbodyElement, tbodyPath] = tbodyEntry;
        const elements = tbodyElement.children.filter(
          (n) => isElement(n) && !editor.isInline(n)
        );
        return Transforms8.moveNodes(editor, {
          at: childPath,
          to: [...tbodyPath, elements.length]
        });
      }
    }
    normalizeNode(entry, options);
  };
  return editor;
}
var immediateTbody = (editor, tablePath) => {
  const [tbody] = Editor13.nodes(editor, {
    match: isOfType(editor, "tbody"),
    at: tablePath
  });
  if (!tbody) {
    return void 0;
  }
  const [, path] = tbody;
  if (!Path4.isChild(path, tablePath)) {
    return void 0;
  }
  return tbody;
};

// src/normalization/normalize-td.ts
import { Node as Node11, Transforms as Transforms9 } from "slate";
function normalizeTd(editor, { blocks: { content, td, th } }) {
  const { normalizeNode } = editor;
  editor.normalizeNode = (entry, options) => {
    const [node, path] = entry;
    if (isElement(node) && [th, td].includes(node.type)) {
      for (const [child, childPath] of Node11.children(editor, path)) {
        if (isElement(child) && content === child.type) {
          continue;
        }
        return Transforms9.wrapNodes(
          editor,
          {
            type: content,
            children: [child]
          },
          { at: childPath }
        );
      }
    }
    normalizeNode(entry, options);
  };
  return editor;
}

// src/normalization/normalize-tr.ts
import { Editor as Editor15, Node as Node12, Transforms as Transforms10 } from "slate";
function normalizeTr(editor, { blocks: { tr, td, th } }) {
  const { normalizeNode } = editor;
  editor.normalizeNode = (entry, options) => {
    const [node, path] = entry;
    if (isElement(node) && node.type === tr) {
      for (const [child, childPath] of Node12.children(editor, path)) {
        if (!isElement(child) || child.type !== td && child.type !== th) {
          const [thead] = Editor15.nodes(editor, {
            match: isOfType(editor, "thead"),
            at: path
          });
          return Transforms10.wrapNodes(
            editor,
            {
              type: thead ? th : td,
              children: [child]
            },
            { at: childPath }
          );
        }
      }
    }
    normalizeNode(entry, options);
  };
  return editor;
}

// src/normalization/with-normalization.ts
function withNormalization(editor, options) {
  if (!options.withNormalization) {
    return editor;
  }
  editor = normalizeAttributes(editor, options);
  editor = normalizeContent(editor, options);
  editor = normalizeSections(editor, options);
  editor = normalizeTable(editor, options);
  editor = normalizeTd(editor, options);
  editor = normalizeTr(editor, options);
  return editor;
}

// src/selection/with-selection.ts
import { Editor as Editor16, Operation as Operation2, Path as Path5, Range as Range4 } from "slate";
function withSelection(editor, { withSelection: withSelection2 }) {
  if (!withSelection2) {
    return editor;
  }
  const { apply } = editor;
  editor.apply = (op) => {
    if (!Operation2.isSelectionOperation(op) || !op.newProperties) {
      TableCursor.unselect(editor);
      return apply(op);
    }
    const selection = __spreadValues(__spreadValues({}, editor.selection), op.newProperties);
    if (!Range4.isRange(selection)) {
      TableCursor.unselect(editor);
      return apply(op);
    }
    const [fromEntry] = Editor16.nodes(editor, {
      match: isOfType(editor, "th", "td"),
      at: Range4.start(selection)
    });
    const [toEntry] = Editor16.nodes(editor, {
      match: isOfType(editor, "th", "td"),
      at: Range4.end(selection)
    });
    if (!fromEntry || !toEntry) {
      TableCursor.unselect(editor);
      return apply(op);
    }
    const [, fromPath] = fromEntry;
    const [, toPath] = toEntry;
    if (Path5.equals(fromPath, toPath) || !hasCommon(editor, [fromPath, toPath], "table")) {
      TableCursor.unselect(editor);
      return apply(op);
    }
    const filled = filledMatrix(editor, { at: fromPath });
    const from = Point.valueOf(0, 0);
    const to = Point.valueOf(0, 0);
    outer:
      for (let x = 0; x < filled.length; x++) {
        for (let y = 0; y < filled[x].length; y++) {
          const [[, path]] = filled[x][y];
          if (Path5.equals(fromPath, path)) {
            from.x = x;
            from.y = y;
          }
          if (Path5.equals(toPath, path)) {
            to.x = x;
            to.y = y;
            break outer;
          }
        }
      }
    let start = Point.valueOf(Math.min(from.x, to.x), Math.min(from.y, to.y));
    let end = Point.valueOf(Math.max(from.x, to.x), Math.max(from.y, to.y));
    for (; ; ) {
      const nextStart = Point.valueOf(start.x, start.y);
      const nextEnd = Point.valueOf(end.x, end.y);
      for (let x = nextStart.x; x <= nextEnd.x; x++) {
        for (let y = nextStart.y; y <= nextEnd.y; y++) {
          const [, { rtl, ltr, btt, ttb }] = filled[x][y];
          nextStart.x = Math.min(nextStart.x, x - (ttb - 1));
          nextStart.y = Math.min(nextStart.y, y - (rtl - 1));
          nextEnd.x = Math.max(nextEnd.x, x + (btt - 1));
          nextEnd.y = Math.max(nextEnd.y, y + (ltr - 1));
        }
      }
      if (Point.equals(start, nextStart) && Point.equals(end, nextEnd)) {
        break;
      }
      start = nextStart;
      end = nextEnd;
    }
    const selected = [];
    const selectedSet = /* @__PURE__ */ new WeakSet();
    for (let x = start.x; x <= end.x; x++) {
      const cells = [];
      for (let y = start.y; y <= end.y; y++) {
        const [[element]] = filled[x][y];
        selectedSet.add(element);
        cells.push(filled[x][y]);
      }
      selected.push(cells);
    }
    EDITOR_TO_SELECTION.set(editor, selected);
    EDITOR_TO_SELECTION_SET.set(editor, selectedSet);
    apply(op);
  };
  return editor;
}

// src/selection/with-selection-adjustment.ts
import { Editor as Editor17, Operation as Operation3, Range as Range5 } from "slate";
function withSelectionAdjustment(editor, { withSelectionAdjustment: withSelectionAdjustment2 }) {
  if (!withSelectionAdjustment2) {
    return editor;
  }
  const { apply } = editor;
  editor.apply = (op) => {
    if (!Operation3.isSelectionOperation(op) || !op.newProperties) {
      return apply(op);
    }
    const selection = __spreadValues(__spreadValues({}, editor.selection), op.newProperties);
    if (!Range5.isRange(selection) || Range5.isCollapsed(selection) || hasCommon(editor, [selection.anchor.path, selection.focus.path], "table")) {
      return apply(op);
    }
    const [anchor] = Editor17.nodes(editor, {
      match: isOfType(editor, "table"),
      at: selection.anchor
    });
    const [focus] = Editor17.nodes(editor, {
      match: isOfType(editor, "table"),
      at: selection.focus
    });
    if (anchor) {
      const [, path] = anchor;
      if (Range5.isBackward(selection)) {
        op.newProperties.anchor = Editor17.end(editor, path);
      } else {
        const start = Editor17.start(editor, path);
        const before = Editor17.before(editor, start);
        op.newProperties.anchor = before != null ? before : start;
      }
    }
    if (focus) {
      const [, path] = focus;
      if (Range5.isBackward(selection)) {
        const start = Editor17.start(editor, path);
        const before = Editor17.before(editor, start);
        op.newProperties.focus = before != null ? before : start;
      } else {
        op.newProperties.focus = Editor17.end(editor, path);
      }
    }
    apply(op);
  };
  return editor;
}

// src/with-table.ts
function withTable(editor, options) {
  const _a = DEFAULT_WITH_TABLE_OPTIONS, { blocks } = _a, rest = __objRest(_a, ["blocks"]);
  const optionsWithDefaults = __spreadProps(__spreadValues(__spreadValues({}, rest), options), {
    blocks: __spreadValues(__spreadValues({}, blocks), options.blocks)
  });
  EDITOR_TO_WITH_TABLE_OPTIONS.set(editor, optionsWithDefaults);
  editor = withDelete(editor, optionsWithDefaults);
  editor = withFragments(editor, optionsWithDefaults);
  editor = withInsertText(editor, optionsWithDefaults);
  editor = withNormalization(editor, optionsWithDefaults);
  editor = withSelection(editor, optionsWithDefaults);
  editor = withSelectionAdjustment(editor, optionsWithDefaults);
  return editor;
}
export {
  TableCursor,
  TableEditor,
  withTable
};
